import { Field } from 'react-final-form'
import { FormInputNumber } from '../forms/final-form-fields'
import { PriceConverter } from '../helpers'
import {
  getPayablePerLabel,
  getPayedOnPremiseLabel,
} from '../account/booking-details/helpers'
import { FormattedMessage } from 'react-intl'
import { useSelector, useDispatch } from 'react-redux'
import { setCourseId } from '../../actions/resort-checkout-actions'
import { addRemoveFromCartTrack } from '../../gtm'
import get from 'lodash/get'
import { Fragment } from 'react'

const setTransferIcon = function(payedPer, isInsurance) {
  // 51,52 = from the resort; 53,54 = to the resort, 56,57 = to and from the resort;
  if(payedPer === 51 || payedPer === 52) {
    return 'icon-transfer-from'
  } else if(payedPer === 53 || payedPer === 54) {
    return 'icon-transfer-to'
  } else if(payedPer === 56 || payedPer === 57) {
    return 'icon-return'
  }

  return ''
}

const showItemPrice = (pricing, quantity = 1, item) => {
  const price = pricing.priceGross

  if(pricing.payedInAdvance === false && !price) {
    return pricing.extraValue
  }

  if(item.initialQuantity && item.priceByQuantity) {
    let amount = 0
    for(let i = 1; i <= quantity; i++) {
      if(item.priceByQuantity[i]) {
        amount += parseFloat(item.priceByQuantity[i])
      } else {
        amount += parseFloat(price)
      }
    }

    return (
      <PriceConverter
        amount={amount}
        currency={pricing.currency}
        noCurrency
        to={!pricing.payedInAdvance ? pricing.currency : undefined}
      />
    )
  }

  if(pricing.payedInAdvance === false && price) {
    return (
      <PriceConverter
        amount={quantity * price}
        currency={pricing.currency}
        to={pricing.currency}
        noCurrency
      />
    )
  }

  return (
    <PriceConverter
      amount={quantity * price}
      currency={pricing.currency}
      noCurrency
    />
  )
}

function OffsetTitle() {
  return (
    <Fragment>
      <p className='offset-product header'>
        <FormattedMessage
          defaultMessage='PROTECT THE PLACES YOU DIVE'
        />
      </p>
      <FormattedMessage
        defaultMessage='Preserve biodiversity and contribute to healthy marine ecosystems with PADI AWARE Foundation.'
      />
      <p className='offset-product hint'>
        <FormattedMessage defaultMessage='(Keep same donation amount at $20 USD)' />
      </p>
    </Fragment>
  )
}

export default function InclusionRow({
  item,
  name,
  showDetailsPopup,
}) {
  const dispatch = useDispatch()
  const shopKind = useSelector((state) => get(state, 'selectedShop.shopKind'))
  const currency = useSelector((state) => state.selectedCurrency)
  const showCoursePopup = () => dispatch(setCourseId(item.id))
  const handleChange = (quantity, type) =>
    addRemoveFromCartTrack(type, quantity, item, shopKind || 10)

  if(item.isMandatory || item.isIncluded) {
    return null
  }

  const itemComment = item.comment || item.fullSetDescription

  return (
    <div className='t-row'>
      <div className='t-cell'>
        <span
          className={`title non-bold ${itemComment ? 'pointer' : ''} ${
            item.isTransfer ? 'with_icon' : ''
          }`}
          data-tip={itemComment}
          data-for='global'
        >
          {item.isTransfer && (
            <i
              className={`font-icons icon ${setTransferIcon(+item.payedPer)}`}
            />
          )}
          {item.isOffsetProduct ? <OffsetTitle /> : item.title}
          {item.isCourse && (
            <p className='small link-color bold' onClick={showCoursePopup}>
              <FormattedMessage
                id='view_incl_excl'
                defaultMessage='View inclusions & exclusions'
              />
              <i className='font-icons info-icon' />
            </p>
          )}
          {(item.isInsurance || item.isOffsetProduct) && (
            <p className='small link-color bold' onClick={showDetailsPopup}>
              <FormattedMessage
                id='view_details'
                defaultMessage='View Details'
              />
              <i className='font-icons info-icon' />
            </p>
          )}
          {itemComment && !item.course && (
            <i className='font-icons info-icon' />
          )}
        </span>
      </div>
      <div className='t-cell relative'>
        <div className='input-counter relative'>
          <Field name={`${name}.quantity`}>
            {(props) => (
              <FormInputNumber
                {...props}
                disabled
                maxNumber={item.maxLimit}
                plusMinusSeparate
                minNumber={0}
                onValueChange={handleChange}
              />
            )}
          </Field>
        </div>
        {getPayedOnPremiseLabel(item, shopKind === 20 ? 'DR' : 'LA')}
      </div>
      <div className='t-cell'>
        {item.isInsurance ? (
          <span className='price green'>
            <FormattedMessage id='free' defaultMessage='Free' />
          </span>
        ) : (
          <span className={`price ${!item.quantity ? 'gray' : ''}`}>
            {!(item.payedInAdvance === false && !item.priceGross) && (
              <small>
                {!item.payedInAdvance ? item.currency : currency}&nbsp;
              </small>
            )}
            {showItemPrice(item, item.quantity || 1, item)}
            {!item.isInsurance && (
              <span className='price-per'>
                (
                {getPayablePerLabel(
                  +item.payedPer,
                  item.quantity,
                  shopKind || 10,
                )}
                )
              </span>
            )}
          </span>
        )}
      </div>
      {item.isFree && (
        <p className='note'>
          <FormattedMessage
            id='free-insurance.note'
            defaultMessage='Please only add this complimentary short-term dive accident insurance if you don’t already have similar coverage'
          />
        </p>
      )}
    </div>
  )
}
